import SelectedItem from "components/partials/selected-items/selected-item/selected-item";
import { IconButton } from "ui/icon-button";

import { TouchpointType } from "types/touchpoint";

import Icons from "assets";

const SelectedRemovableItem = ({
  id,
  name,
  latestVersion,
  type,
  onRemove,
  showStatus = false,
  showBatch = false,
  touchpointBatchName,
}: {
  id: string;
  name: string;
  latestVersion?: { id?: string; version?: number; status?: string | null } | null;
  type: TouchpointType;
  onRemove: (itemId: string) => void;
  showStatus?: boolean;
  showBatch?: boolean;
  touchpointBatchName?: string;
}) => (
  <div className="flex items-center justify-between bg-gray-50 rounded-md pr-1 shadow">
    <SelectedItem
      name={name}
      latestVersion={latestVersion}
      type={type}
      showStatus={showStatus}
      showBatch={showBatch}
      touchpointBatchName={touchpointBatchName}
    />

    <IconButton
      size="small"
      color="inherit"
      variant="text"
      aria-label="Remove item"
      onClick={() => onRemove(id)}>
      <Icons.Close className="size-3 text-aqua-600" />
    </IconButton>
  </div>
);

export default SelectedRemovableItem;
